import css from './index.module.scss';
import { LineSpace } from '@/componentsH5/ProductComponents';
import { BannerModule, ImgCellsWithText, TextWithImage } from '@/componentsH5/ProductDetailComponents';
import { getDetaileMoreProducts } from '@/utils';
import { useGlobal } from '@/utils/useGlobal';
import OtherList from '@/components/ProductCommon/OtherList';
import NextImage from '@/components/NextImage';

const product: any = {
    us: ['product_ps_river_river_pro_720', 'product_ps_delta_delta_1300', 'product_ps_delta_delta_max'],
    cis: ['product_ps_river_river_256'],
    eu: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    uk: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    de: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    fr: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    es: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    it: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    tw: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    kr: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    cn: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    br: ['product_ps_river_river_256', 'product_ps_delta_delta_2_max', 'product_ps_delta_delta_2'],
    mx: ['product_ps_river_703', 'product_ps_river_river_768', 'product_ps_river_river_512'],
    ph: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
};

export default function SolarPanel() {
    const { gloproductlist, useLang, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('110wsolarpanel');
    const languageT = (value: string) => t(`solarpanels_110w.${value}`);
    const webpUrl = '/media/solarpanel_110w/h5/';

    const imgCellData = {
        guide: languageT('eight_title'),
        title: languageT(locale === 'jp' ? 'eight_subtitle_h5' : 'eight_subtitle'),
        desc1: languageT('eight_des'),
        desc2: languageT('eight_des1'),
        items: [
            {
                url: ['8_solar-panel1.webp', '8_solar-panel1.jpg'],
                guide: languageT('eight_item_title'),
                titleLeft: languageT('eight_item_hours'),
                desc: languageT('eight_item_des'),
            },
            {
                url: ['8_solar-panel2.webp', '8_solar-panel2.jpg'],
                guide: languageT('eight_item1_title'),
                titleLeft: languageT('eight_item1_hours'),
                desc: languageT('eight_item1_des'),
            },
            {
                url: ['8_solar-panel3.webp', '8_solar-panel3.jpg'],
                guide: languageT('eight_item2_title'),
                titleLeft: languageT('eight_item2_hours'),
                desc: languageT('eight_item2_des'),
            },
            {
                url: ['8_solar-panel4.webp', '8_solar-panel4.jpg'],
                guide: languageT('eight_item3_title'),
                titleLeft: languageT('eight_item3_hours'),
                desc: languageT('eight_item3_des'),
            },
        ],
    };

    return (
        <div className={`${css.animationWrapper} solarPanelModule`}>
            <div className="page-solarpanel-banner">
                <BannerModule
                    data={[
                        {
                            bgImgs: ['KV.webp', 'KV.jpg'],
                            title: languageT('title'),
                            des: languageT('des'),
                        },
                    ]}
                    config={{ isShowLogo: false, theme: 'black', webpUrl }}
                />
            </div>

            <div className="banner-content">
                <div className="section section1">
                    <h3 className="tit">{languageT('second_powerfully')}</h3>
                    <div className="bg-img">
                        <NextImage
                            webpSrc={require('@publicLocal/product/solarpanel_110w/h5/section1.webp')}
                            src={require('@publicLocal/product/solarpanel_110w/h5/section1.jpg')}
                            className="fullImgs"
                            alt={languageT('second_powerfully')}
                        />
                    </div>
                </div>
                <div className="section section2">
                    <div className="sec2-top">
                        <div className="section sec2-top-l">
                            <h3
                                className="tit"
                                dangerouslySetInnerHTML={{
                                    __html: t.raw('solarpanels_110w.second_adjustable_h5'),
                                }}
                            ></h3>
                            <div className="bg-img">
                                <NextImage
                                    webpSrc={require('@publicLocal/product/solarpanel_110w/h5/sec2-top-l.webp')}
                                    src={require('@publicLocal/product/solarpanel_110w/h5/sec2-top-l.jpg')}
                                    className="fullImgs"
                                    alt={languageT('second_adjustable_h5')}
                                />
                            </div>
                        </div>
                        <div className="section sec2-top-r">
                            <h3
                                className="tit"
                                dangerouslySetInnerHTML={{
                                    __html: t.raw('solarpanels_110w.second_easy_to_plug_h5'),
                                }}
                            ></h3>
                            <div className="bg-img">
                                <NextImage
                                    webpSrc={require('@publicLocal/product/solarpanel_110w/h5/sec2-top-r.webp')}
                                    src={require('@publicLocal/product/solarpanel_110w/h5/sec2-top-r.jpg')}
                                    className="fullImgs"
                                    alt={languageT('second_easy_to_plug_h5')}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="section sec2-btm">
                        <h3
                            className="tit"
                            dangerouslySetInnerHTML={{
                                __html: t.raw('solarpanels_110w.second_hight_conversion_rate'),
                            }}
                        ></h3>
                        <div className="bg-img">
                            <NextImage
                                webpSrc={require('@publicLocal/product/solarpanel_110w/h5/sec2-btm.webp')}
                                src={require('@publicLocal/product/solarpanel_110w/h5/sec2-btm.jpg')}
                                className="fullImgs"
                                alt={languageT('second_hight_conversion_rate')}
                            />
                        </div>
                    </div>
                </div>
                <div className="section section3">
                    <h3 className="tit">
                        <span className="ipText">{languageT('second_waterproof')}</span>
                        <span className="ip">{languageT('second_ip')}</span>
                    </h3>
                    <div className="bg-img">
                        <NextImage
                            webpSrc={require('@publicLocal/product/solarpanel_110w/h5/section3.webp')}
                            src={require('@publicLocal/product/solarpanel_110w/h5/section3.jpg')}
                            className="fullImgs"
                            alt={languageT('second_waterproof')}
                        />
                    </div>
                </div>
            </div>
            <div className="textImg">
                <TextWithImage
                    config={{ isShowVideo: false, position: 'top', webpUrl }}
                    data={{
                        synopsis: languageT(locale === 'jp' ? 'third_title_h5' : 'third_title'),
                        desc: languageT('third_des'),
                        img_url: ['3_panels.webp', '3_panels.jpg'],
                    }}
                />
            </div>
            <LineSpace height={0.8} background="transparent" />
            <div className="textImg">
                <TextWithImage
                    config={{ isShowVideo: false, fullScreen: false, position: 'top', webpUrl }}
                    data={{
                        synopsis: languageT('four_title'),
                        desc: languageT('four_des'),
                        img_url: ['4_energy.webp', '4_energy.jpg'],
                    }}
                />
            </div>
            <LineSpace height={0.8} background="transparent" />
            <div className="textImg">
                <TextWithImage
                    config={{ isShowVideo: false, fullScreen: false, position: 'top', webpUrl }}
                    data={{
                        synopsis: languageT('five_title_h5'),
                        desc: languageT('five_des'),
                        img_url: ['5_energy.webp', '5_energy.jpg'],
                    }}
                />
            </div>
            <LineSpace height={0.8} background="transparent" />
            <div className="textImg">
                <TextWithImage
                    config={{ isShowVideo: false, fullScreen: false, position: 'top', webpUrl }}
                    data={{
                        synopsis: languageT('six_title'),
                        desc: languageT('six_des'),
                        tip: languageT('six_tip'),
                        img_url: ['6_material.webp', '6_material.jpg'],
                    }}
                />
            </div>
            <LineSpace height={0.8} background="transparent" />
            <div className="textImg">
                <TextWithImage
                    config={{
                        isShowVideo: false,
                        fullScreen: false,
                        position: 'top',
                        synopsisFontSize: locale === 'de' ? 0.22 : 0.24,
                        webpUrl,
                    }}
                    data={{
                        synopsis: languageT(locale === 'jp' ? 'seven_title_h5' : 'seven_title'),
                        desc: languageT('seven_des'),
                        img_url: ['7_energy.webp', '7_energy.jpg'],
                    }}
                />
            </div>
            <LineSpace height={1} background="transparent" />
            <div className="products">
                <ImgCellsWithText data={imgCellData} webpUrl={webpUrl} />
                {locale === 'cn' && <p className="memo">{languageT('memo')}</p>}
            </div>
            <LineSpace height={1.2} background="transparent" />
            {/* {locale !== 'br' && ( */}
            <OtherList
                data={getDetaileMoreProducts(
                    gloproductlist,
                    product[locale] || product.us,
                    '',
                    '',
                    `https://${locale}.ecoflow.com/collections/portable-power-stations`,
                )}
            />
            {/* )} */}
        </div>
    );
}
